module.exports = __webpack_public_path__ + "img/processos.7e1742e6.svg";